import { render, staticRenderFns } from "./ZhiqiTong2.vue?vue&type=template&id=935c6a50&scoped=true"
import script from "./ZhiqiTong2.vue?vue&type=script&lang=js"
export * from "./ZhiqiTong2.vue?vue&type=script&lang=js"
import style0 from "./ZhiqiTong2.vue?vue&type=style&index=0&id=935c6a50&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "935c6a50",
  null
  
)

export default component.exports